<template>
  <header class="topbar">
    <div class="container container-flex flex-align-center">
      <h1 id="topbar-title" class="topbar__title">
        <router-link v-if="goBackButtonTo" :to="goBackButtonTo">
          <img src="~@/assets/icons/icon-prev-black.svg" class="topbar__back-icon" />
        </router-link>
        <img v-else @click="$emit('action')" src="~@/assets/icons/icon-prev-black.svg" class="topbar__back-icon" />
        <span class="topbar__heading">
          <slot name="title">{{ title }}</slot>
        </span>
      </h1>
      <a href="#" class="btn btn--icon topbar__export">
        <slot></slot>
      </a>
    </div>
  </header>
</template>

<script>
export default {
  name: "VSubheader",
  props: {
    goBackButtonTo: {
      type: [String, Object]
    },
    title: {
      type: String
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables";
.topbar {
  min-height: 104px;
  background: #fdfdfd;
  box-shadow: 0 38px 46px -48px rgba(0, 0, 0, 0.75);
  display: flex;
  align-items: center;
  position: relative;
  z-index: 2;
  &__heading {
    .bold {
      font-weight: bold;
    }
  }
  &__title {
    font-size: 24px;
    line-height: 26px;
    letter-spacing: 0.8px;
    color: #333333;
  }

  &__back-icon {
    margin-right: 10px;
    position: relative;
    top: 0px;
    cursor: pointer;
  }

  &__form {
    background: url("~@/assets/icons/icon-search.svg") #fdfdfd 18px center no-repeat;
    border: 1px solid #ececec;
    border-radius: 100px;
    margin: 0 0 0 39px;
    min-width: 470px;
    display: flex;
    align-items: center;
    padding: 0 21px 0 0;
    @media all and (max-width: 1200px) {
      width: 380px;
    }
  }
  &__input {
    background: none;
    padding: 0 0 0 46px;
    border: none;
    height: 40px;
    font-size: 13px;
    line-height: 14px;
    outline: none;
    width: 330px;
    outline: 0;
    @media all and (max-width: 1200px) {
      width: 260px;
    }
    &::placeholder {
      color: #999999;
      opacity: 1;
    }
  }
  &__import {
    margin-left: auto;
    text-transform: none;
    letter-spacing: 0;
    padding: 0;
    background: none;
    outline: none;
  }
  &__export {
    margin: 0 0 0 auto;
    text-transform: uppercase;
    letter-spacing: 1.25px;
    font-weight: bold;
  }
  .counter-box {
    margin-right: 18px;
    margin-left: auto;
  }
  &__buttons {
    .button {
      padding: 0 0 0 24px;
      background: none;
      color: #004593;
      display: inline-block;
      white-space: nowrap;
      margin: 0 0 0 9px;
      vertical-align: middle;
      min-width: 192px;
      img {
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  &__selected-text {
    font-size: 24px;
    span {
      margin: 8px 16px 0 7px;
      background: url("~@/assets/icons/icon-cancel-black.svg");
      text-indent: -99999px;
      display: inline-block;
      width: 14px;
      height: 14px;
      vertical-align: middle;
      cursor: pointer;
    }
  }
}
</style>
